#import "../fragments/entity-summary-fragment.graphql"

mutation RateEntitySummary($input: EntitySummaryRateInput!) {
    entitySummaryRate(input: $input) {
        entitySummary {
            ...EntitySummaryFragment
        }
    }
}
